import {
    getPendingUploads,
    getAudioFromIndexedDB,
    deleteAudioFromIndexedDB,
    removePendingUpload,
    updateRetryCount,
} from "./audioUploadQueue"

let isProcessing = false

export const processPendingUploads = async (audioUploadFn, setAudioFileId) => {
    if (typeof window === "undefined") return

    if (isProcessing) return

    isProcessing = true

    try {
        const pending = getPendingUploads()

        if (pending.length === 0) {
            console.log("No pending uploads to process lublubdubdub")
            isProcessing = false
            return
        }

        console.log(
            `Processing ${pending.length} pending audio uploads... lublubdubdub`
        )

        for (const metadata of pending) {
            try {
                // Retrieve audio from IndexedDB
                const record = await getAudioFromIndexedDB(metadata.id)

                if (!record || !record.blob) {
                    console.error(
                        "Audio blob not found in IndexedDB:",
                        metadata.id
                    )
                    removePendingUpload(metadata.id)
                    continue
                }

                console.log(
                    "Attempting to upload pending audio: lublubdubdub",
                    metadata.id
                )

                // Prepare FormData from stored data
                const formData = new FormData()
                formData.append(
                    "mediaFile",
                    new File([record.blob], metadata.audioFileName, {
                        type: "audio/webm",
                        lastModified: Date.now(),
                    })
                )
                formData.append("description", metadata.description)
                formData.append("topics", metadata.topics)
                formData.append("duration", metadata.duration)
                formData.append("mediaType", metadata.mediaType)
                formData.append("languageId", metadata.languageId)

                metadata.userIds.forEach(userId => {
                    formData.append("userIds", userId)
                })

                formData.append("programId", metadata.programId)
                if (metadata.appointmentId) {
                    formData.append("appointmentId", metadata.appointmentId)
                }

                // Attempt upload
                await new Promise((resolve, reject) => {
                    audioUploadFn(
                        formData,
                        async () => {
                            // Success
                            await deleteAudioFromIndexedDB(metadata.id)
                            removePendingUpload(metadata.id)
                            if (setAudioFileId) {
                                setAudioFileId(metadata.audioFileName)
                            }
                            console.log(
                                "✓ Successfully uploaded pending audio: lublubdubdub",
                                metadata.id
                            )
                            resolve()
                        },
                        error => {
                            // Failure
                            const newRetryCount = (metadata.retryCount || 0) + 1
                            updateRetryCount(metadata.id, newRetryCount)
                            console.error(
                                "✗ Failed to upload pending audio:",
                                metadata.id,
                                error
                            )
                            reject(error)
                        }
                    )
                })
            } catch (error) {
                console.error(
                    "Error processing pending upload:",
                    metadata.id,
                    error
                )
                // Keep in queue for next attempt
            }
        }
    } finally {
        isProcessing = false
    }
    console.log("Finished processing pending uploads lublubdubdub")
}
